import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { XCircle } from 'lucide-react';

const PaymentCancelled = () => {
  const navigate = useNavigate();
  const role = localStorage.getItem('signup_role') || 'member';

  return (
    <div className="min-h-screen bg-black text-white flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <Card className="bg-gray-900 border-gray-800">
          <CardHeader className="text-center">
            <div className="flex items-center justify-center mb-4">
              <div className="w-16 h-16 flex items-center justify-center">
                <img 
                  src="https://customer-assets.emergentagent.com/job_refined-login/artifacts/7hacqtlv_Success%20Club%20Logo%20Files%20-%203%20%281%29.png" 
                  alt="Success Club Logo" 
                  className="w-full h-full object-contain"
                  style={{ filter: 'brightness(0) invert(1)' }}
                />
              </div>
            </div>
            <CardTitle className="text-2xl text-white">
              Payment Cancelled
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="text-center">
              <XCircle className="w-16 h-16 text-orange-500 mx-auto mb-6" />
              <h3 className="text-2xl font-semibold text-white mb-4">Payment Cancelled</h3>
              <p className="text-gray-300 mb-6">
                Your payment was cancelled. No charges were made to your account.
              </p>
              
              <div className="bg-gray-800 border border-gray-700 rounded-lg p-4 mb-6">
                <p className="text-gray-300 text-sm">
                  To complete your Success Club membership and access all features, 
                  you'll need to complete the payment process.
                </p>
              </div>
              
              <div className="space-y-3">
                <Button
                  onClick={() => navigate('/email-verification', { 
                    state: { 
                      email: localStorage.getItem('signup_email'),
                      requiresPayment: true 
                    } 
                  })}
                  className="w-full bg-amber-600 hover:bg-amber-700 text-white"
                >
                  Try Again
                </Button>
                
                <Button
                  onClick={() => navigate('/auth')}
                  variant="outline"
                  className="w-full border-gray-600 text-gray-300 hover:bg-gray-800"
                >
                  Back to Sign Up
                </Button>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default PaymentCancelled;